import { render } from "./NoflightsError.vue?vue&type=template&id=2acae73f&scoped=true"
import script from "./NoflightsError.vue?vue&type=script&lang=js"
export * from "./NoflightsError.vue?vue&type=script&lang=js"

import "./NoflightsError.vue?vue&type=style&index=0&id=2acae73f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acae73f"]])

export default __exports__